<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Provisionsrechnungen</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle">Seriennummer</th>
                <th class="text-center align-middle" 
                  @click="
                    sortListing(
                      'invoice_no',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                  >Rechnungsnummer
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'invoice_no'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'invoice_no' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'invoice_no' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle" @click="
                    sortListing(
                      'dealer_company',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  ">Firmenname
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'dealer_company'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'dealer_company' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'dealer_company' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle" @click="
                    sortListing(
                      'send_date',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  ">Rechnungsdatum
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'send_date'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'send_date' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'send_date' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle" @click="
                    sortListing(
                      'net_amount',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  ">Nettorechnungsbetrag
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'net_amount'"
                    ></i>
                    <i class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'net_amount' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'net_amount' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span></th>
                <th class="text-center align-middle">Fällig</th>
                <th class="text-center align-middle">Bezahlt</th>
                <th class="text-center align-middle">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchInvoiceKey"
                    solo
                    label="Rechnungsnummer suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchCompanyNameKey"
                    solo
                    label="Firmenname suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td></td>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-select
                    :items="statusDueItems"
                    v-model="searchStatusDueKey"
                    item-text="title"
                    item-value="value"
                    label="Status suchen..."
                    solo
                    clearable
                  />
                </div>
                
              </td>
              <td>
                <div class="search-input-div">
                  <v-select
                    :items="statusItems"
                    v-model="searchStatusKey"
                    item-text="title"
                    item-value="value"
                    label="Status suchen..."
                    solo
                    clearable
                  />
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="invoices.length">
              <tr v-for="(invoice, i) in invoices" :key="invoice.id">
                <td
                  class="align-middle text-left clickable-td"
                 
                >
                  {{ i + 1 }}
                </td>
                <td
                  class="align-middle clickable-td"
                 
                >
                  {{ invoice.invoice_no }}
                </td>

                <td
                  class="align-middle clickable-td"
                  v-if="invoice.producer_details && invoice.producer_details.company_name"
                >
                  {{ invoice.producer_details.company_name }}
                </td>
                <td
                  class="align-middle clickable-td"
                  v-else
                >
                  -
                </td>
                
                <td
                  class="align-middle clickable-td"
                 
                >
                  {{ invoice.send_date }}
                </td>
                <td
                  class="align-middle clickable-td"
                 
                >
                  {{ invoice.net_amount }} €
                </td>
                <td class="text-center clickable-td">
                  <input type="checkbox" title="fällig" name="payemt_settlement" :v-model="'payemt_settlement'+invoice.id" :checked='invoice.payment_due_status == "1" ? true : false' :id="'settle_' + invoice.id"  @change="changePaymentStatus(invoice.id,invoice.payment_due_status,'due')"/>
                </td>
                <td class="text-center clickable-td">
                  <input type="checkbox" title="bezahlt" name="payemt_settlement" :v-model="'payemt_settlement'+invoice.id" :checked='invoice.payment_paid_status == "1" ? true : false' :id="'settle_' + invoice.id"  @change="changePaymentStatus(invoice.id,invoice.payment_paid_status,'paid')" />

                </td>
                
                <td class="align-middle icon-wrapper-block text-center">
                 
                  <a
                    :href="invoice.invoice_path"
                    target="_blank"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="file-earmark"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Download Rechnung</span>
                    </v-tooltip>
                  </a>
                  
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_orders" class="loading-tbody">
              <td class="text-center" colspan="10">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td class="text-center" colspan="10">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="orders" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
import config from "@/config/app.js";

Vue.use(Notifications);

export default {
  name: "Invoices",
  created() {
    // console.log('enter');
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("bar_book_a_order_user_access_id");
      this.getInvoices();
    }
  },
  data() {
    return {
      currencySybmol: config.CURRENCY_SYMBOL,
      loading_orders: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchCompanyNameKey: "",
      searchInvoiceKey: "",
      statusItems: [
        {
          title: "bezahlt",
          value: "1",
        },
        {
          title: "nicht bezahlt",
          value: "0",
        },
        
      ],
      statusDueItems: [
        {
          title: "fällig",
          value: "1",
        },
        {
          title: "nicht fällig",
          value: "0",
        },
        
      ],
      searchPriceKey: "",
      searchStatusKey: "",
      searchStatusDueKey: "",
      
      userId: null,
      showFileModal: false,
      order_shipped: false,
      modalFile: null,
      invoices: [],
      statusDialog: false,
      deleteDialog: false,
      deleteRecordId: null,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchCompanyNameKey: {
      handler: function (val, oldVal) {
        this.invoices = [];
        this.loading_orders = true;
        this.getInvoices();
      },
      deep: true,
    },
    searchInvoiceKey: {
      handler: function (val, oldVal) {
        this.invoices = [];
        this.loading_orders = true;
        this.getInvoices();
      },
      deep: true,
    },
    searchStatusKey: {
      handler: function (val, oldVal) {
        this.invoices = [];
        this.loading_orders = true;
        this.getInvoices();
      },
      deep: true,
    },
    searchStatusDueKey: {
      handler: function (val, oldVal) {
        this.invoices = [];
        this.loading_orders = true;
        this.getInvoices();
      },
      deep: true,
    },

  },
  methods: {
    goToDetails(id) {
      this.$router.push({
        path: "/dealer/order/" + btoa(parseInt(id)),
        target: "_blank",
      });
    },
    changePaymentStatus(invoiceId,payment_status,type) {
      payment_status = payment_status == "0" ? "1" : "0";
      // console.log(payment_status);
      // return false;
      this.loading_orders = true;
      let data = {'invoice_id':invoiceId, 'payment_status':payment_status, 'type':type }
      adminAPI
        .updatePaymentStatus(data)
        .then((response) => {
          if (response.status == "success") {
            this.loading_orders = false;
            // this.$notify({
            //   group: "orders",
            //   type: "success",
            //   position: "bottom right",
            //   text: response.msg,
            //   duration: 3000,
            // });
            this.getInvoices();
          }
        })
        .catch((err) => {
          // console.log(err);
          this.loading_orders = true;
        });
    },
    goToAddNew() {
      this.$router.push({ name: "add-order" });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_orders) {
        this.invoices = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_orders = true;
        this.getInvoices();
      }
    },
    paginationChange() {
      this.invoices = [];
      this.loading_orders = true;
      setTimeout(() => {
        this.getInvoices();
      }, 100);
    },
    getInvoices() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        search_company_name_field: this.searchCompanyNameKey,
        search_invoice_field: this.searchInvoiceKey,
        search_payment_status_field: this.searchStatusKey,
        search_payment_due_status_field: this.searchStatusDueKey,
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
      };

      adminAPI
        .getInvoices(data)
        .then((response) => {
          if (response.status == "success") {
            this.invoices = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_orders = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_orders = false;
            this.$notify({
              group: "orders",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_orders = false;
          this.$notify({
            group: "orders",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
.clickable-td {
  cursor: pointer;
}
</style>